import {
  ListSubaccountUserInvitesQuery,
  ListSubaccountUsersQuery,
  ListTenantUserInvitesQuery,
  ListTenantUsersQuery,
} from "~frontend/__generated__/graphql";

export type SubaccountUser =
  ListSubaccountUsersQuery["listSubaccountUsers"]["users"][number];
export type TenantUser =
  ListTenantUsersQuery["listTenantUsers"]["users"][number];
export type User = SubaccountUser | TenantUser;

export type SubaccountUserInvite =
  ListSubaccountUserInvitesQuery["listSubaccountUserInvites"]["userInvites"][number];
export type TenantUserInvite =
  ListTenantUserInvitesQuery["listTenantUserInvites"]["userInvites"][number];
export type UserInvite = SubaccountUserInvite | TenantUserInvite;

export enum UserStatus {
  INVITED = "invited",
  ACTIVE = "active",
}
